module.exports = __webpack_public_path__ + "img/dash.951d489f.svg";